var _defs, _circle, _g, _circle2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSummary = function SvgSummary(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comunicacion",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.36 226.38",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7b8fb5;}.cls-2{fill:#5073b5;}.cls-3{fill:none;isolation:isolate;}.cls-4{fill:rgba(161,168,181,0);}.cls-5{fill:#a1a8b5;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_110",
    className: "cls-1",
    cx: 112.68,
    cy: 113.1,
    r: 111.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_774",
    className: "cls-4",
    x: 34.28,
    y: 40.05,
    width: 146.11,
    height: 146.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_817",
    className: "cls-5",
    d: "m150.56,69.88c-23.73-23.89-62.34-24.02-86.23-.28-17.76,17.65-22.93,44.36-13.04,67.35.59,1.21.78,2.58.55,3.9l-5.37,25.79c-.7,3.27,1.39,6.49,4.67,7.19.47.1.95.14,1.43.13h1.22l26.09-5.24c1.33-.16,2.67.03,3.9.55,30.93,13.31,66.8-.97,80.11-31.9,9.9-23,4.73-49.72-13.04-67.37l-.3-.12Zm-67.5,49.21c-3.37,0-6.1-2.73-6.1-6.1s2.73-6.1,6.1-6.1c3.37,0,6.1,2.73,6.1,6.1h0c0,3.37-2.73,6.1-6.1,6.1Zm24.39,0c-3.37,0-6.1-2.73-6.1-6.1,0-3.37,2.73-6.1,6.1-6.1,3.37,0,6.1,2.73,6.1,6.1h0c0,3.37-2.73,6.1-6.1,6.1h0Zm24.39,0c-3.37,0-6.1-2.73-6.1-6.1s2.73-6.1,6.1-6.1c3.37,0,6.1,2.73,6.1,6.1s-2.73,6.1-6.1,6.1h0Z"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_124",
    className: "cls-2",
    cx: 163.41,
    cy: 67.93,
    r: 27.67
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.36,80.74c-1.68,0-3.27-.25-4.78-.76-1.51-.51-2.77-1.22-3.79-2.14l1.27-2.83c1.11.9,2.25,1.56,3.44,1.98,1.18.42,2.43.64,3.75.64,1.7,0,2.99-.37,3.88-1.1.89-.73,1.33-1.78,1.33-3.15s-.44-2.38-1.33-3.05c-.89-.66-2.17-.99-3.84-.99h-3.86v-3.08h3.51c1.49,0,2.66-.38,3.52-1.13.86-.76,1.29-1.79,1.29-3.12,0-1.2-.4-2.13-1.2-2.78-.8-.65-1.95-.97-3.44-.97-2.53,0-4.73.91-6.62,2.73l-1.28-2.8c.97-.97,2.18-1.72,3.63-2.25,1.45-.53,2.97-.8,4.55-.8,2.5,0,4.45.57,5.84,1.72,1.39,1.15,2.09,2.73,2.09,4.76,0,1.37-.35,2.57-1.05,3.61-.7,1.04-1.66,1.79-2.89,2.27,1.49.38,2.63,1.1,3.44,2.18.8,1.07,1.2,2.39,1.2,3.95,0,2.2-.77,3.93-2.32,5.21-1.55,1.28-3.67,1.91-6.36,1.91Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSummary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "summary.c375c20322e13e59b10a02054093c0a2.svg";